import { render, staticRenderFns } from "./FeedbackSnack.vue?vue&type=template&id=f02ebb48"
import script from "./FeedbackSnack.vue?vue&type=script&lang=js"
export * from "./FeedbackSnack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports